const func = ($target) => {
	if($('.image-slideshow .swiper-wrapper .swiper-slide').length > 1) {
		window.loader.key("swiper", function () {
			var $wrapper = $target.find(".image-slideshow");
			var slideSwiper = new Swiper($wrapper, {
				slidesPerView: 1,
				spaceBetween: 0,
				effect: "slide",
				updateOnImagesReady: true,
				navigation: {
					nextEl: $target.find(".image-slideshow-button-next"),
					prevEl: $target.find(".image-slideshow-button-prev"),
				},
				pagination: {
                    el: ".image-slideshow-pagination",
                },
				breakpointsInverse: true,
				on: {
					imagesReady: function () {
						$target.find(".slideshow-content").addClass("show");
						$target.removeClass("preload");
					},
				},
			});
			
			slideSwiper.on('slideNextTransitionStart',function(){
				if($(".image-slideshow .swiper-button-next").hasClass("swiper-button-disabled") && $('.image-slideshow .swiper-slide-next').length){
					$(".image-slideshow .swiper-button-next").removeClass("swiper-button-disabled");
					$(".image-slideshow .swiper-button-next").attr("aria-disabled", "false");
				}
			})

			slideSwiper.on('slidePrevTransitionStart',function(){
				if($(".image-slideshow .swiper-button-prev").hasClass("swiper-button-disabled") && $('.image-slideshow .swiper-slide-prev').length){
					$(".image-slideshow .swiper-button-prev").removeClass("swiper-button-disabled");
					$(".image-slideshow .swiper-button-prev").attr("aria-disabled", "false");
				}
			})
		});
	} else {
		$target.find(".slideshow-content").addClass("show");
		$target.removeClass("preload");
	}
};

export default func;
